import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    padding: 1rem;
  }


  .page-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--sl-color-neutral-700);
  }

  sl-tab-group {
    margin-bottom: 1.5rem;
  }

  .tab-content {
    padding: 1rem 0;
  }




  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
  }

  .error {
    background: var(--sl-color-danger-50);
    border: 1px solid var(--sl-color-danger-200);
    border-radius: 6px;
    padding: 1rem;
    color: var(--sl-color-danger-700);
    margin-bottom: 1rem;
  }

  .empty-state {
    text-align: center;
    padding: 3rem;
    color: var(--sl-color-neutral-500);
  }

  .empty-state sl-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: var(--sl-color-neutral-300);
  }

  .empty-state h3 {
    margin: 0 0 0.5rem 0;
    color: var(--sl-color-neutral-600);
  }

  .empty-state p {
    margin: 0;
    font-size: 0.875rem;
  }
`;
